<template>
  <div class="listContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>设置</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a @click="showInUserList">管理员</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section v-show="!hideInAddShow && !hideInUserEdit">
      <section class="searchBox">
        <span class="addStyle">
          <a-button
            type="primary"
            icon="plus"
            @click="hideInAddShow = !hideInAddShow"
            >增加</a-button
          >
        </span>
        <span>
          <label>项目：</label>
          <a-select
            placeholder="请选择项目"
            showSearch
            :filterOption="filterOption"
            optionFilterProp="children"
            style="min-width: 200px; margin-right: 20px"
            v-model="project_id"
          >
            <a-select-option
              :value="item.id"
              v-for="(item, i) in proList"
              :key="i"
              >{{ item.project_name }}</a-select-option
            >
          </a-select>
        </span>
        <span>
          <label>字符串：</label>
          <div>
            <a-input
              placeholder="请输入姓名 | 手机号"
              v-model="query_field"
              style="margin-right: 20px"
            />
          </div>
        </span>
        <span>
          <a-button @click="reactPage" style="margin-right: 10px"
            >重置</a-button
          >
          <a-button type="primary" icon="search" @click="onSearch"
            >搜索</a-button
          >
        </span>
      </section>
      <!-- 增加&搜索 end-->
      <section class="tableStyles">
        <table>
          <thead>
            <tr>
              <th v-for="item in thList" :key="item">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data == ''">
              <td></td>
              <td></td>
              <td>暂无</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr v-show="data.length > 0" v-for="(item, i) in data" :key="i">
              <td>{{ item.project_name }}</td>
              <td>{{ item.user_name }}</td>
              <td>
                <p v-show="item.role_type == 1">项目总监</p>
                <p v-show="item.role_type == 2">项目经理</p>
                <p v-show="item.role_type == 3">驻场</p>
              </td>
              <td style="width: 30%">
                <span v-show="item.role_type == 2">{{ item.shop_name }}</span>
                <p v-show="item.role_type == 1">all</p>
              </td>
              <td></td>
              <td class="operation">
                <a @click="edit(item)">编辑</a>
                <a style="color: #f56c6c" @click="unbind(item)">解绑</a>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>

    <!-- 增加 -->
    <addAdministrator v-on:hideInAdd="hideInAdd" v-show="hideInAddShow" />
    <!-- 增加 end-->
    <!-- 编辑 -->
    <administratorEdit
      v-on:hideInEdit="hideInEdit"
      v-show="hideInUserEdit"
      :editDetail="editDetail"
    />
    <!-- 编辑  end-->
  </div>
</template>
<script>
import axios from "axios";
import addAdministrator from "@/components/manpower/addAdministrator"; //增加
import administratorEdit from "@/components/manpower/administratorEdit"; //编辑

export default {
  components: {
    addAdministrator,
    administratorEdit
  },
  data() {
    return {
      data: {},
      loading: false,
      page: 1,
      pagination: {},
      hideInAddShow: false,
      query_field: "",
      typeSearch: -1,
      hideInUserEdit: false,
      editDetail: {},
      totalPage: Number,
      thList: ["项目", "姓名", "身份", "管理范围", "底薪类型", "操作"],
      proList: [],
      project_id: ""
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  mounted() {
    this.getData(); //获取列表
    this.getPro(); //获取项目
  },
  methods: {
    unbind(val) {
      let _this = this;
      this.$confirm({
        title: "提示",
        content: "是否解绑该用户权限?",
        onOk() {
          _this.unbindHttp(val);
        }
      });
    },
    unbindHttp(val) {
      let url =
        this.httpsBasic.url + this.httpsBasic.people + "People_role/unbindRole";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken"),
        id: val.id
      };
      axios.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.$message.success("解绑成功");
          this.reload();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    reactPage() {
      this.project_id = "";
      this.query_field = "";
      this.page = 1;
      this.getData();
    },
    getPro() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/queryManagerProject";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          trade_id: 5
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proList = res.data.data;
            //  console.log(this.proList);
          }
        });
    },
    onChange(pageNumber) {
      this.page = pageNumber;
      this.getData();
    },
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    hideInAdd(msg) {
      this.hideInAddShow = msg;
      this.reload();
    },
    hideInEdit(msg) {
      this.hideInUserEdit = msg;
      this.reload();
    },
    showInUserList() {
      this.hideInAddShow = false;
      this.hideInUserEdit = false;
    },
    onSearch(value) {
      this.page = 1;
      // this.query_field = value;
      this.getData();
      // console.log(value);
    },
    getData() {
      // console.log(this.$store.state.token);
      this.loading = true;
      this.data = [];
      let url =
        this.httpsBasic.url +
        this.httpsBasic.people +
        "People_role/insideRoleList";
      axios
        .post(url, {
          current_page: this.page,
          per_page: 10,
          project_id: this.project_id,
          query_field: this.query_field,
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.data = res.data.data.data;
            // console.log(this.data);
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    handleChange(value, key, column) {
      const newData = [...this.data];
      const target = newData.filter(item => key === item.id)[0];
      if (target) {
        target[column] = value;
        this.data = newData;
      }
    },
    edit(detail) {
      this.hideInUserEdit = true;
      this.editDetail = detail;
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
.areaStyle {
  p {
    display: inline-block;
  }
}
.listContainer {
  .searchBox {
    display: block;
    .addStyle {
      margin-right: 20px;
    }
    > span {
      display: inline-block;
      margin-bottom: 10px;
      margin-right: 10px;
      > div {
        display: inline-block;
      }
    }
  }
}
</style>
<style lang="less">
.ant-table {
  min-height: 58vh;
}
</style>
